import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from "@chakra-ui/react";

interface IOpBWSModalProps {
  onClose: () => void;
  isOpen: boolean;
}

const OpBWSModal: React.FC<IOpBWSModalProps> = ({
  onClose,
  isOpen,
}: IOpBWSModalProps) => {
  return (
    <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>What is opBWS?</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            We will explain opBWS in details here.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Got It
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default OpBWSModal;
